import React, { useEffect, useState } from "react";
import ThemeCard from "../../components/ThemeCard";
import { Col, Form, Row, notification } from "antd";
import ThemeInput from "../../components/ThemeInput";
import ThemeDatePicker from "../../components/ThemeDatePicker";
import APICall from "../../APICall";
import EndPoints from "../../APICall/EndPoints";
import ThemeDropDown from "../../components/ThemeDropDown";
import { useSelector } from "react-redux";
import {
  LedgerSuffix,
  SubmitButton,
  ThemeForm,
} from "../AccountPointEntry/style";
import ThemeInputNumber from "../../components/ThemeInputNumber/ThemeInputNumber";
import { useWatch } from "antd/es/form/Form";
import { useGetChildUsers } from "../../APICall/apiHooks";
import dayjs from "dayjs";

function AccountPointJVEntry() {
  // state
  const [userOption, setUserOption] = useState([]);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [form] = Form.useForm();
  // redux
  const userDetail = useSelector((state) => state.authSlice.userDetail);

  // custom hook for childUser api call
  const { isLoading, childUsers: childData } = useGetChildUsers({
    type: "onlychild",
    id: userDetail?.userId,
  });

  const debit = useWatch("debitFrom", form)?.[0];
  const credit = useWatch("creditTo", form)?.[0];

  // api call
  const onSubmit = async (value) => {
    // make payload with credit and debit account
    const payload = {
      ...value,
      creditTo: value?.creditTo?.[0],
      debitFrom: value?.debitFrom?.[0],
      type: "JV",
      remark: value?.remark || null,
    };

    try {
      setSubmitLoading(true);
      let response = await APICall("post", EndPoints.createLedger, payload);

      if (response.status === 200) {
        notification.success({ message: response.data?.message });
        form.resetFields();
      } else {
        notification.error({ message: response.data?.message });
      }
    } catch (error) {
      notification.error({ message: error?.message });
    } finally {
      setSubmitLoading(false);
    }
  };

  // life cycle
  useEffect(() => {
    // set user option
    if (childData) {
      setUserOption(() => {
        const list = childData.map((el) => {
          return {
            label: `${el?.accountName} (${el?.userId})`,
            value: el?.userId,
          };
        });
        return list;
      });
    }
  }, [childData]);

  // function
  const handleCancel = () => {
    form.resetFields();
  };

  const handleFinish = (value) => {
    onSubmit(value);
  };

  const handleFailed = (error) => {
    notification.error({ message: error?.errorFields?.[0]?.errors?.[0] });
  };
  const debitId = useWatch("debitFrom", form)?.[0];
  const creditId = useWatch("creditTo", form)?.[0];

  const debitLedger = childData?.find(
    (el) => el?.userId === debitId
  )?.ledgerBalance;
  const creditLedger = childData?.find(
    (el) => el?.userId === creditId
  )?.ledgerBalance;

  return (
    <ThemeCard title={"Account Point JV Entry"}>
      <ThemeForm
        form={form}
        onFinish={handleFinish}
        onFinishFailed={handleFailed}
        labelCol={{ xs: 24, sm: 8, md: 10, lg: 10, xl: 10 }}
        wrapperCol={{ xs: 24, sm: 12, md: 10, lg: 8, xl: 6 }}
        style={{ display: "flex", flexDirection: "column", gap: "1.5rem" }}
      >
        <ThemeDropDown
          name="debitFrom"
          placeholder="Select"
          options={userOption?.filter((el) => el?.value !== credit)}
          showSearch={true}
          style={{ width: "100%" }}
          suffixIcon={
            <LedgerSuffix ledgerBalance={debitLedger}>
              {debitLedger}
            </LedgerSuffix>
          }
          disabled={isLoading}
          form_props={{
            name: "debitFrom",
            label: "Debit Account",
            rules: [{ required: true }],
          }}
        />

        <ThemeDropDown
          name={"creditTo"}
          placeholder="Select"
          options={userOption?.filter((el) => el?.value !== debit)}
          showSearch={true}
          style={{ width: "100%" }}
          suffixIcon={
            <LedgerSuffix ledgerBalance={creditLedger}>
              {creditLedger}
            </LedgerSuffix>
          }
          disabled={isLoading}
          form_props={{
            name: "creditTo",
            label: "Credit Account",
            rules: [{ required: true }],
          }}
        />

        <ThemeDatePicker
          width={"100%"}
          formProps={{
            name: "date",
            label: "Date",
            initialValue: dayjs(Date.now()),
            rules: [{ required: true }],
          }}
        />

        <ThemeInputNumber
          marginBottom={"0rem"}
          style={{ width: "100%" }}
          inputProps={{ name: "point" }}
          errorheight="0rem"
          formProps={{
            name: "point",
            label: "Point",
            rules: [{ required: true }],
          }}
        />

        <ThemeInput
          marginBottom={"0rem"}
          style={{ width: "100%" }}
          inputProps={{ name: "remark" }}
          formProps={{
            name: "remark",
            label: "Remark",
          }}
        />

        <Row justify={"center"} style={{ marginTop: "2rem" }} gutter={[20, 20]}>
          <Col xs={24} sm={8} md={4} lg={4} xl={3}>
            <SubmitButton
              loading={submitLoading}
              type="primary"
              htmlType="submit"
            >
              Submit
            </SubmitButton>
          </Col>
          <Col xs={24} sm={8} md={4} lg={4} xl={3}>
            <SubmitButton remove={"true"} onClick={handleCancel}>
              Cancel
            </SubmitButton>
          </Col>
        </Row>
      </ThemeForm>
    </ThemeCard>
  );
}

export default AccountPointJVEntry;
